import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
// Icons
import { IoMdMenu } from 'react-icons/io';
// Images
import SammiSmithLogo from '../../assets/images/logos/mistress-sammi-smith-pink-logo.png';
// Context
import { useUser } from '../../context/UserContext';
// Constants
import { CompanyName } from '../../utils/Constants';
import { HOME_PAGE_URL } from '../../utils/Routes';
// Hooks
import useNavigateToPage from '../../hooks/useNavigateToPage';
import { getNavLinkItemsArray } from '../../utils/data/NavData';
// Nav data

function Navbar() {
  const { user, setUser } = useUser();
  const navigateToPage = useNavigateToPage();
  const navLinkItemsArray = getNavLinkItemsArray(user);

  const [isPhoneNavOpen, setIsPhoneNavOpen] = useState(false);

  const togglePhoneNav = () => {
    setIsPhoneNavOpen((prev) => !prev);
  };

  const handleLogout = (event) => {
    event.preventDefault();
    setUser({});
    localStorage.removeItem(process.env.REACT_APP_USER_TOKEN);
    navigateToPage(HOME_PAGE_URL, { replace: true });
  };

  return (
    <nav role='navigation' aria-label='Main Navigation' className='relative'>
      {/* Phone */}
      <section className='grid max-h-20 border-solid border-colour1 border-b-4 lg:hidden grid-cols-2 px-2 py-1'>
        <section className=''>
          <NavLink to={HOME_PAGE_URL}>
            <img
              src={SammiSmithLogo}
              alt={`${CompanyName} business logo`}
              className='min-w-10 w-fit max-h-[68px] h-auto cursor-pointer object-fill active:scale-95'
            />
          </NavLink>
        </section>

        <section className='grid items-center pr-2 justify-end'>
          {/* Mobile screen */}
          <button
            aria-label='Toggle navigation menu'
            onClick={togglePhoneNav}
            className='grid lg:hidden w-fit h-fit items-center justify-center text-4xl text-colour1 cursor-pointer'
          >
            <IoMdMenu className='active:scale-90 duration-300' />
          </button>
        </section>
      </section>

      {/* Large screen */}
      <section className='hidden lg:grid px-4 pt-8 pb-4'>
        <div className='grid justify-center'>
          {/* Large screen */}
          <ul className='grid grid-flow-col gap-6 xl:gap-8 items-center font-titleFont text-colour1'>
            {navLinkItemsArray.map(({ path, label }) => (
              <NavItem key={label} url={path} title={label} />
            ))}
            {user?.email && (
              <li>
                <button
                  className='text-3xl lg:text-2xl text-colour1 font-titleFont hover:brightness-90 duration-200 active:scale-75'
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            )}
          </ul>
        </div>
      </section>

      {/* Phone navbar */}
      <section
        className={`phone-nav absolute top-full left-0 w-full bg-colour2 border-solid border-colour1 border-b-4 transition-transform duration-300 ${
          isPhoneNavOpen
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <ul className='grid gap-8 items-center justify-center text-center text-colour1 py-10'>
          {navLinkItemsArray.map(({ path, label }) => (
            <NavItem key={label} url={path} title={label} />
          ))}

          {user?.email && (
            <li>
              <button
                className='text-3xl lg:text-2xl text-colour1 font-titleFont hover:brightness-90 duration-200 active:scale-75'
                onClick={handleLogout}
              >
                Logout
              </button>
            </li>
          )}
        </ul>
      </section>
    </nav>
  );
}

const NavItem = ({ url, title }) => {
  return (
    <li className='active:scale-95'>
      <NavLink
        to={url}
        aria-label={`${title} page navigation tab`}
        className='text-3xl lg:text-2xl font-titleFont text-colour1 hover:brightness-90 hover:underline underline-offset-[6px] duration-300'
        aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
        style={({ isActive }) =>
          isActive
            ? {
                color: 'var(--colour1)',
                textDecoration: 'underline',
                textDecorationThickness: '2px',
                textUnderlineOffset: '5px',
              }
            : {}
        }
      >
        {title}
      </NavLink>
    </li>
  );
};

export default Navbar;
